/**
 * Internal dependencies
 */
import border from './border';
import color from './color';
import spacing from './spacing';
import typography from './typography';

export const styleDefinitions = [
	...border,
	...color,
	...spacing,
	...typography,
];
